import React from 'react';

import _ from 'lodash';
import cx from 'classnames';
import { connect } from 'react-redux';

import LoginRequired from 'shared/HOCs/LoginRequired';

import { getTenderCode } from 'shared/utils/tenders';
import { formatDate } from 'shared/utils/dates';
import Loader from 'shared/components/Loader';
import LoadMoreView from 'shared/components/LoadMoreView';
import ClosingDateBox from 'shared/components/ClosingDateBox';

import { fetchTenders, deleteState, fetchNextTenders } from '../ducks';
import NoTenders from '../NoTenders';

import { OPEN_FILTERS } from './constants';

import styles from './styles.module.scss';

const TableCell = ({ label, children, vertical = false }) => (
  <div className={cx(styles.cell, { [styles.vertical]: vertical })}>
    <div className={styles.label}>{label}</div>
    <div className={styles.content}>{_.isNil(children) ? '-' : children}</div>
  </div>
);

class OpenTenders extends React.Component {
  componentDidMount() {
    this.props.fetchTenders(OPEN_FILTERS);
  }

  componentWillUnmount() {
    this.props.deleteState();
  }

  render() {
    const { tenders, isFetching, nextUrl, fetchNextTenders } = this.props;

    return _.isEmpty(tenders) && !isFetching ? (
      <div className={styles.noTendersContainer}>
        <NoTenders type="open" changeActiveTab={this.props.changeActiveTab} />
      </div>
    ) : (
      <>
        <div className={styles.pageDescription}>
          Please find below a list of your open Projects. The responses will
          become visible after the closing date.
        </div>
        <div className={styles.tendersTable}>
          <div className={cx(styles.tableHeader, 'remove-sm')}>
            <div className={styles.title} />
            <div className={styles.tenderCode}>Code</div>
            <div className={styles.companiesContacted}>Companies Contacted</div>
            <div className={styles.responses}>Responses</div>
            <div className={styles.totalVisits}>Total Visits</div>
            <div className={styles.uniqueVisits}>Unique Visits</div>
            <div className={styles.completionRate}>Completion Rate</div>
            <div className={styles.averageTimeToComplete}>
              Avg Time to Complete
            </div>
          </div>
          <LoadMoreView
            loadMore={() => fetchNextTenders({ nextUrl })}
            hasMore={!_.isNil(nextUrl)}
            isLoading={isFetching}
            loader={<Loader />}>
            {tenders.map((tender, index) => (
              <div key={index} className={cx(styles.tableRow, 'remove-sm')}>
                <div className={styles.title}>
                  <ClosingDateBox className={styles.closingDateBox}>
                    Closing {formatDate(tender.closing_date)}
                  </ClosingDateBox>
                  {tender.title}
                </div>
                <div className={styles.tenderCode}>{getTenderCode(tender)}</div>
                <div className={styles.companiesContacted}>
                  {tender.companies_contacted}
                </div>
                <div className={styles.responses}>{tender.response_count}</div>
                <div className={styles.totalVisits}>{tender.total_visits}</div>
                <div className={styles.uniqueVisits}>
                  {tender.unique_visits}
                </div>
                <div className={styles.completionRate}>
                  {tender.completion_rate}
                </div>
                <div className={styles.averageTimeToComplete}>
                  {tender.avg_time_to_complete}
                </div>
              </div>
            ))}

            {tenders.map((tender, index) => (
              <div key={index} className={styles.mobileTableRow}>
                <TableCell vertical label="Title">
                  <ClosingDateBox className={styles.closingDateBox}>
                    Closing {formatDate(tender.closing_date)}
                  </ClosingDateBox>
                  {tender.title}
                </TableCell>
                <TableCell vertical label="Code">
                  {getTenderCode(tender)}
                </TableCell>
                <TableCell vertical label="Companies Contacted">
                  {tender.companies_contacted}
                </TableCell>
                <TableCell vertical label="Responses">
                  {tender.response_count} Response(s)
                </TableCell>
                <TableCell vertical label="Total Visits">
                  {tender.total_visits}
                </TableCell>
                <TableCell vertical label="Unique Visits">
                  {tender.unique_visits}
                </TableCell>
                <TableCell vertical label="Completion Rate">
                  {tender.completion_rate}
                </TableCell>
                <TableCell vertical label="Avg Time to Complete">
                  {tender.avg_time_to_complete}
                </TableCell>
              </div>
            ))}
          </LoadMoreView>{' '}
        </div>
      </>
    );
  }
}
const mapStateToProps = state => {
  const { tenders, isFetching, nextUrl } = state.pages.tender.create;
  return {
    nextUrl,
    tenders,
    isFetching
  };
};

const mapDispatchToProps = {
  fetchTenders,
  deleteState,
  fetchNextTenders
};
export default LoginRequired(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OpenTenders)
);
